import { useQuery } from '@tanstack/react-query';
import { channelsApi } from '../services';

export type { ChannelDropdownItem } from '../services';

/**
 * Canais no formato dropdown (rota `/channels/dropdown`, sem permissionMiddleware).
 *
 * DONO ÚNICO da chave `['channels','dropdown']`. Antes existia um segundo hook
 * de mesmo nome em `attendance-management` com a MESMA chave achatada
 * (`['channels-dropdown']`) e tipo de retorno diferente — quem carregasse
 * primeiro definia o que o outro lia.
 *
 * A forma hierárquica é o que faz os `invalidateQueries({ queryKey: ['channels'] })`
 * do módulo (criar/editar/excluir/ativar/reconectar canal) alcançarem o dropdown
 * por prefixo. Com a chave achatada, nada o invalidava.
 *
 * `enabled` existe para consumo dentro de drawers/abas: hooks rodam antes do
 * `if (!isOpen) return null`, então o call-site precisa poder adiar o fetch.
 */
export const useChannelsDropdown = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ['channels', 'dropdown'],
    queryFn: () => channelsApi.getForDropdown(),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
};
